export const GOOG_BASE_URL = 'https://jnn-pa.googleapis.com';
export const YT_BASE_URL = 'https://www.youtube.com';
export const GOOG_API_KEY = 'AIzaSyDyT5W0Jh49F30Pqqtyfdf7pDLFKLJoAnw';
export const USER_AGENT = 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36(KHTML, like Gecko)';
